<template>
  <div class="container text-center">
    <h1>
      About Me
    </h1>
    <hr />
    <div style="padding-left: 10px;">
      <MarkdownView :html="aboutHtml" />
    </div>
  </div>
</template>

<script>
import MarkdownView from '@/components/MarkdownView.vue'

let About = null
try {
  About = require('@/../posts/data/about.md')
} catch (e) {
  About = require('@/defaults/about.md')
}

export default {
  name: 'AboutMe',
  components: {
    MarkdownView
  },
  data: function () {
    return {
      // Mode.HTML 下 .md 产出 { html, attributes },取 html 字符串
      aboutHtml: (About && About.html) || ''
    }
  },
  mounted: function () {
    this.changeTitle('About')
  }
}
</script>
